import React, { useRef } from "react";
import Footer from "../components/footer";
import NavBar from "../components/navbar";
import ContactForm from "../components/ContactForm";
import Login from "../components/login";

export default function Contact() {
  return (
    <div>
      <NavBar/>
      <ContactForm/>
      <Footer/>
    </div>
  );
}